import { m } from 'framer-motion';
// @mui
import { Container, Typography } from '@mui/material';
// hooks
import useStaffAccess from '../hooks/useStaffAccess';
// components
import MotionContainer from '../components/animate/MotionContainer';
import { varBounce } from '../components/animate/variants/bounce';
// assets
import ForbiddenIllustration from '../assets/illustration_403';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  // Staff roles that may open the page; any one of the user's roles is enough
  roles?: string[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  const { hasAnyRole } = useStaffAccess();

  if (typeof roles !== 'undefined' && !hasAnyRole(roles)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Your role does not allow this page. Ask the owner if you need it.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}
